import { DataTable } from "@/components/data-table";
import { themesColumns } from "@/features/themes/components/themes-columns";
import { useTranslation } from "react-i18next";
import EmptyTable from "@/components/empty-table";
import { useThemesList } from "@/features/themes/hooks/useThemesList";
import SearchInput from "@/components/search-input";
import ListContent from "@/features/themes/components/list-content";
import { useThemesFilterStore } from "@/features/themes/stores";
import ThemesFilterComponent from "@/features/themes/components/filter-component";
import { ROUTES } from "@/constants/routes";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { selectedRowsAtom } from "@/stores/atoms/selected-rows-atom";
import { useEffect } from "react";

const ThemesListPage = () => {
  const { t } = useTranslation();
  const [rowSelection, setRowSelection] = useAtom(selectedRowsAtom);
  const { themes, page, pageCount, setPage, isLoading, isFetching } =
    useThemesList();
  const { searchValue, setSearchValue } = useThemesFilterStore();

  useEffect(() => {
    return () => setSearchValue(null);
  }, [setSearchValue]);

  return (
    <div className="flex flex-col gap-y-3 pt-3 sm:pt-6 pb-24 relative">
      <div className="flex items-center gap-2 lg:hidden px-3 sm:px-6">
        <SearchInput
          value={searchValue ?? ""}
          onChange={setSearchValue}
          placeholder={t("keys.search")}
        />
        <ThemesFilterComponent />
      </div>
      <div className="hidden md:block overflow-x-scroll px-3 sm:px-6">
        <DataTable
          columns={themesColumns(t)}
          data={themes}
          page={page}
          pageCount={pageCount}
          onPageChange={setPage}
          isLoading={isLoading || isFetching}
          emptyListComponent={<EmptyTableComponent />}
          rowSelection={rowSelection}
          onRowSelectionChange={setRowSelection}
        />
      </div>
      <ListContent
        data={themes}
        isLoading={isLoading || isFetching}
        page={page}
        pageCount={pageCount}
        onPageChange={setPage}
        className="md:hidden"
        emptyListComponent={<EmptyTableComponent />}
        rowSelection={rowSelection}
        onRowSelectionChange={setRowSelection}
      />
    </div>
  );
};

const EmptyTableComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <EmptyTable
      title={t("modules.themes.datatable.no_themes")}
      subtitle={t("modules.themes.datatable.add_theme")}
      action={() => navigate(ROUTES.THEME_CREATE)}
      actionTitle={t("modules.themes.keys.add_theme")}
    />
  );
};

export default ThemesListPage;
